import {useMemo} from 'react'
import {findImagesBy} from '../utils/image-groups-utils'
import {useCroVariantActive} from '../components/cro'
import {CRO_EXPERIMENTS} from '../constants'
import useOcapiSite from './useOcapiSite'

// map product ids to front images to replace for the CRO71 experiment
// use relative links and they will be prepended with the https dis base from ocapi site
// and the master catalog path
// NOTE: this requires the images to be uploaded with the same name in the master catalog
// on DEV, STG and PRD to work correctly
const CRO71_PRODUCT_IMAGE_REPLACE = {
    'tripp-trapp-highchair': '/images/cro/cro71/Tripp%20Trapp%20Highchair%20Bundle.jpg',
    'tripp-trapp-newborn-complete':
        '/images/cro/cro71/Tripp%20Trapp%20Highchair%20Bundle%20+%20Newborn%20Set.jpg',
    'tripp-trapp-newborn-bundle':
        '/images/cro/cro71/Tripp%20Trapp%20Highchair%20Newborn%20Bundle.jpg',
    'tripp-trapp-highchair-tray':
        '/images/cro/cro71/TrippTrapp%20Highchair%20Bundle%20+Stokke%20Tray.jpg',
    'tripp-trapp-highchair-cushion':
        '/images/cro/cro71/Tripp%20Trapp%20Highchair%20Bundle%20+%20Cushion.jpg'
}

export const useProductDisplayImages = (
    product,
    viewType,
    selectedVariationAttributes,
    imagesCount
) => {
    const imageGroups = product?.imageGroups
    const frontImage = product?.c_extraMainImage
    const backImage = product?.c_extraMainImage2
    const {httpsDisBaseUrl, stokkeMasterCatalog} = useOcapiSite()
    const isCro71ProductImagesActive = useCroVariantActive(
        CRO_EXPERIMENTS.cro71ProductImages.experimentId,
        CRO_EXPERIMENTS.cro71ProductImages.variantId
    )
    const result = useMemo(() => {
        const images = findImagesBy(imageGroups, frontImage, backImage, {
            viewType,
            selectedVariationAttributes
        })

        // replace the first image with the CRO71 product image if the experiment is active
        // and we have a matching replacement image
        if (
            isCro71ProductImagesActive &&
            images?.length > 0 &&
            CRO71_PRODUCT_IMAGE_REPLACE[product?.id]
        ) {
            // construct the dis base link with the master catalog path
            const disBaseWithMasterCatalog = httpsDisBaseUrl + new URL(stokkeMasterCatalog).pathname
            images[0] = {
                // we don't have a better alt text, so reuse from the original image
                ...images[0],
                // replace both dis and link with the CRO71 image using the ENV specific dis base and master catalog path
                // NOTE: this means the image must be uploaded with the same name in the master catalog
                // on DEV, STG and PRD to work correctly
                disBaseLink: disBaseWithMasterCatalog + CRO71_PRODUCT_IMAGE_REPLACE[product.id],
                link: disBaseWithMasterCatalog + CRO71_PRODUCT_IMAGE_REPLACE[product.id]
            }
        }

        if (imagesCount) {
            return images?.slice(0, imagesCount) || []
        }
        return images || []
    }, [
        imageGroups,
        viewType,
        selectedVariationAttributes,
        frontImage,
        backImage,
        imagesCount,
        // CRO71 begin
        isCro71ProductImagesActive,
        httpsDisBaseUrl,
        product?.id,
        stokkeMasterCatalog
        // CRO71 end
    ])
    return result
}
